import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './taskDelegation.intl.json';

export const useTaskDelegationIntl = () => useIntlModule(messages);
